import { EventEmitter, Injectable, OnDestroy } from '@angular/core';
import { CommunicationService } from '../../communication/communication.service';
import { take, takeUntil } from 'rxjs/operators';
import { ConfiguredToastrService } from '../../helper/toastr/configured-toastr.service';
import { AnessaTranslationService } from '../../helper/translation/anessa-translation.service';
import { saveAs } from 'file-saver';
import {ReportElement} from '../../results/baseline/baseline-summary/baseline-summary.component';

@Injectable({
  providedIn: 'root'
})
export class ResultsServiceService implements OnDestroy{

  private onDestroyNotifier = new EventEmitter();

  constructor(
    private commService: CommunicationService,
    private toastrService: ConfiguredToastrService,
    private translationService: AnessaTranslationService
  ) {

  }

  ngOnDestroy() {
    this.onDestroyNotifier.emit();
    this.onDestroyNotifier.unsubscribe();
  }

  public generateResultsSummaryReportCall(reportPack: {elements: ReportElement[], config: Object}) {
    this.commService.fileRequest(reportPack, '/wsasapi/report/generateResultsSummaryReport')
      .pipe(take(1))
      .pipe(takeUntil(this.onDestroyNotifier))
      .subscribe(
        res => {
          this.toastrService.success(this.translationService.get('SERVICE.REPORT.REPORT_GENERATED'), undefined);
          let fileName = reportPack.config['title'];
          fileName = fileName.replace(/[ &\/\\#,+()$~%.'":*?<>{}]/g, '');
          saveAs(res, fileName);
        }
      );
  }
}
